module.exports = __webpack_public_path__ + "static/media/img_gift@2x.887f45b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_gift@2x.png
// module id = 922
// module chunks = 0